export default __webpack_public_path__ + "static/cta-753532cc63a33dd41436805f03ac73c2.svg";